import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import RoleServices from '@/services/apis/role';
const initialState = {
  permissionAssociatedRoles: [],
  permissionAssociatedRolesCount: 0,
  roles: [],
  tot_count: 0,
  loading: true,
  error: false,
  errorMessage: '',
  status: 'idle',
  result: {}
};

export const fetchPermissionAssociatedRoles = createAsyncThunk(
  'roles/fetchPermissionAssociatedRoles',
  async ({ domainName, orgName, page, rowsPerPage, roleName, appName, appType, permName, permType }: any) => {
    const response = await RoleServices.fetchAllRoles({
      domainName,
      orgName,
      pageNumber: page,
      pageSize: rowsPerPage,
      roleName: roleName,
      appName,
      appType,
      permName,
      permType
    });
    return response;
  }
);

export const fetchAllRoles = createAsyncThunk(
  'roles/fetchAllRoles',
  async ({ domainName, orgName, page, rowsPerPage, roleName, appName, appType, permName, permType }: any) => {
    const response = await RoleServices.fetchAllRoles({
      domainName,
      orgName,
      pageNumber: page,
      pageSize: rowsPerPage,
      roleName: roleName,
      appName,
      appType,
      permName,
      permType
    });
    return response;
  }
);

export const createNewRole = createAsyncThunk('roles/createNewRole', async (rolesData: any) => {
  const data = await RoleServices.createRole(rolesData);
  return data;
});
export const updateRole = createAsyncThunk('roles/updateRole', async (rolesData: any) => {
  const { roleId, ...finalData } = rolesData;
  const data = await RoleServices.updateRole(finalData, roleId);
  return data;
});
export const deleteRole = createAsyncThunk('roles/deleteRole', async (role: any) => {
  const data = await RoleServices.deleteRoles(role);
  return data;
});

export const deleteBulkRole = createAsyncThunk('roles/deleteBulkRole', async (role: any) => {
  const data = await RoleServices.deleteBulkRoles(role);
  return data;
});

export const downloadRole = createAsyncThunk('roles/downloadRole', async () => {
  const response = await RoleServices.downloadRole();
  return response;
});

export const downloadCsv = createAsyncThunk('roles/downloadCsv', async () => {
  const response = await RoleServices.downloadCsv();
  return response;
});
export const uploadRoles = createAsyncThunk(
  'group/uploadRoles',
  async ({ dom_name,org_name, data, created_by, modified_by, status,app_name,app_type,role_type }: any) => {
    const response = await RoleServices.uploadCsv({ dom_name,org_name,app_name,app_type,role_type, data, created_by, modified_by, status });
    return response;
  }
);
export const RolesSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAllRoles.pending, (state) => {});
    builder.addCase(fetchAllRoles.fulfilled, (state, { payload }) => {
      return {
        ...state,
        roles: payload?.result?.roles || [],
        result: payload?.result,
        tot_count: payload?.totalRecords,
        loading: false
      };
    });
    builder.addCase(fetchAllRoles.rejected, (state) => {
      return { ...state, roles: [], result: {}, tot_count: 0, loading: false };
    });
    builder.addCase(fetchPermissionAssociatedRoles.pending, (state) => {});
    builder.addCase(fetchPermissionAssociatedRoles.fulfilled, (state, { payload }) => {
      return {
        ...state,
        permissionAssociatedRoles: payload?.result?.roles,
        result: payload?.result,
        permissionAssociatedRolesCount: payload?.totalRecords,
        loading: false
      };
    });
    builder.addCase(fetchPermissionAssociatedRoles.rejected, (state) => {
      return { ...state, permissionAssociatedRoles: [], result: {}, permissionAssociatedRolesCount: 0, loading: false };
    });
  }
});

export const roleSelector = (state: any) => state.role;

export default RolesSlice.reducer;
